import React  from 'react';
import {FieldViewProps} from "../../../render/view";
import Task from "../../../../model2/task/task";
import TaskTypeIcon from "../../../../gd-components/icons/task-icon/task-icon-ui5";
import GDProjectName from "../../../../gd-ui/project-name/project-name";

export default function FieldTask_GListView(props:FieldViewProps) {

    const task = _.get(props.model, props.field.fieldId, null) as Task

    if (!task) return null

    const classes = Classes("flex-row-left-center ", "", props.className, {
        // 'invalid-value': !props.field.isValueValid(value)
    })

    return (
        <div className={classes}>
            <TaskTypeIcon taskTypeId={task.taskTypeId} size="14" className="m-r-5"/>
            <span className="ui5-txt-less-important-small txt-truncate no-wrap">{task.title}</span>

            <GDProjectName className="m-l-10"
                                  projectId={task.projectId}
                                  type="ui5-prop"
                                  hintFullPath={true} />
        </div>
    );
}
